// extracted by mini-css-extract-plugin
module.exports = {"menuLinks":"_b18cbc9","link":"_dc2571a"};